import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const packageSlice = createSlice({
  name: "auth",
  initialState: {
    loading: false,
    list: [],
    data: {},
    createLoading: false,
    isStatusChange: false,
    getLoading: false,
    editLoading: false,
    packageReports: []  
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    getLoading: (state, action) => {
      state.getLoading = action.payload;
    },
    createLoading: (state, action) => {
      state.createLoading = action.payload;
    },
    createPackageStatus: (state, action) => {
      state.isStatusChange = true;
    },
    editLoading: (state, action) => {
      state.editLoading = action.payload;
    },
    getPackages: (state, action) => {
      state.list = action.payload.data;
    },
    onePackageData: (state, action) => {
      state.data = { ...action.payload.package, day_visits: action.payload.day_visits };
    },
    clearStateChange: (state, action) => {
      state.isStatusChange = false;
    },
    getPackageReports: (state, action) => {
      state.packageReports = action.payload.data;
    }
    
  }
});

export const { getPackages, loading, createLoading, clearStateChange, getLoading, onePackageData, editLoading, createPackageStatus, getPackageReports } = packageSlice.actions;

export const getPackageList = () =>
  async (dispatch) => {
    try {
      dispatch(loading(true));
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_all_packages`;
      const { data } = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(getPackages(data));
      dispatch(loading(false));
    } catch (error) {
      toast.error(error.response.data.error);
      dispatch(loading(false));
      errorHandling(error);
    }
  };

export const createPackage = (packageData, navigate) =>
  async (dispatch) => {
    try {
      dispatch(createLoading(true));
      dispatch(clearStateChange());
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/store_package`;
      const { data } = await axios.post(url, packageData, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(createPackageStatus());
      toast("Package Created Successfully...");
      navigate(-1);
      dispatch(createLoading(false));
    } catch (error) {
      toast.error(error.response.data.error);
      dispatch(createLoading(false));
      errorHandling(error);
    }
  };

export const getPackageDetails = (id) =>
  async (dispatch) => {
    try {
      dispatch(getLoading(true));
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/edit_packages/${id}`;
      const { data } = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(onePackageData(data));
      dispatch(getLoading(false));
    } catch (error) {
      // toast.error(error.response.data.error);
      dispatch(getLoading(false));
      errorHandling(error);
    }
  };

export const updatePackage = (id, formData, navigate) =>
  async (dispatch) => {
    try {
      dispatch(editLoading(true));
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_package/${id}`;
      const { data } = await axios.post(url, formData, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(createPackageStatus());
      navigate(-1);
      dispatch(editLoading(false));
    } catch (error) {
      toast.error(error.response.data.error);
      dispatch(editLoading(false));
      errorHandling(error);
    }
  };

export const deletePackage = (id, setDeletableId, setModal) =>
  async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/destroy_package/${id}`;
      const { data } = await axios.post(url, {}, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(createPackageStatus());
      setModal(false);
      setDeletableId(null);
    } catch (error) {
      toast.error(error.response.data.error);
      errorHandling(error);
    }
  };

export const getPackageReportsDetails = () =>
  async (dispatch) => {
    try {
      dispatch(loading(true));
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/package_report`;
      const { data } = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(getPackageReports(data));
      dispatch(loading(false));
    } catch (error) {
      errorHandling(error);
    }
  };  

export default packageSlice.reducer;